export const STORAGE_KEYS = {
  accessToken: 'reach.auth.accessToken',
  refreshToken: 'reach.auth.refreshToken',
  locale: 'reach.i18n.locale',
  timezone: 'reach.i18n.timezone',
  theme: 'reach.theme',
  themePrimary: 'reach.theme.primary',
  themeSecondary: 'reach.theme.secondary',
  themeTertiary: 'reach.theme.tertiary',
  encryptionSalt: 'reach.crypto.salt',
  draftPrefix: 'reach.draft.',
  featureFlags: 'reach.flags',
  permissions: 'reach.permissions'
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
